import { createSlice } from "@reduxjs/toolkit";
import { getEducation } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const initialState = {status:API_STATUS.IDEL,educationData:[]};
const educationSlice = createSlice({
    name:'education',
    initialState,
    reducers:{ },
    extraReducers:(builder)=>{
        builder.addCase(getEducation.fulfilled, (state, action)=>{
           
            state.educationData = action.payload;
            state.status = API_STATUS.IDEL;
        }),
        builder.addCase(getEducation.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(getEducation.rejected, (state, action)=>{
           
            state.status = API_STATUS.ERROR;
        })
    }
});

export const {} = educationSlice.actions;
export default educationSlice.reducer;